import { useState, useEffect, Fragment } from "react";
import { useFormikContext } from "formik";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import Field from "../../../utils/FormikFields/Field";
import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";
import { InputLabel, autoCompleteDisplayLabel } from "../../../utils/Common";

import { formatGenericDate } from "../../../utils/util";

import { useInvoiceData } from "../../../contexts/InvoiceData";

import { displayLabelCustomer } from "../../../utils/displayLabels";

import EditCustomer from "../../Customers/EditCustomer";

const SelectCustomer = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  const [serverOptions, setServerOptions] = useState(null);

  let { invoice_data } = useInvoiceData() || {};

  let repairs = values?.repairs || [];

  useEffect(() => {
    if (invoice_data?.customer) {
      setServerOptions([{...invoice_data.customer}]);
      setFieldValue('customer_id', invoice_data.customer.customer_id);
      setFieldValue('invoice_id', invoice_data.invoice_id);
    }
  }, [invoice_data?.customer?.customer_id])

  console.log(values, "values");


  useEffect(() => {
    if (values.backend_data_loaded) {
      let customer = {
        customer_id: values.customer_id,
        full_name: values.client_name,
        mobile_phone: values?.customer_phone || ""
      }
      console.log(customer, "customer");
      setServerOptions([{...customer}]);
    }
  }, [values.backend_data_loaded])

  return (
    <Fragment>
      <Grid size={{xs: 12}}>
        <InputLabel>Customer Name</InputLabel>
        <AutoCompleteSolo 
          name = "customer_id"
          url = "customers"
          fieldName = "customer_id"
          displayField= "full_name"
          formUpdates = {[{name: "customer_name", field: "full_name"}, {name: "customer_phone", field: "mobile_phone"}]}
          displayLabel = {displayLabelCustomer} 
          serverOptions={serverOptions}
          setDisplayField = "customer_name"
          disabled = {repairs.length > 0 || invoice_data?.customer?.customer_id}
          newItemTitle = "Customer"
          server={true}
          FormComponent={<EditCustomer dialog={true} />}
        />
      </Grid>
    </Fragment>
  )

};

export default SelectCustomer;